import ClassNames from "classnames";
import { FunctionComponent } from "react";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import { ColorScheme, TitleAndSubtitleTextAlign } from "../types/index.js";
import { css } from "../utils/emotion.js";
import MultilineText from "./MultilineText.js";

interface Props {
  isFirstOnPage: boolean;
  textAlign: TitleAndSubtitleTextAlign;
  className?: string;
  wrapperClassName?: string;
  title: string;
  subtitle: string | undefined;
  scheme: ColorScheme;
}

const ModuleHeadings: FunctionComponent<Props> = ({
  isFirstOnPage,
  className,
  wrapperClassName,
  textAlign,
  title,
  subtitle,
  scheme,
}) => {
  const TagName = isFirstOnPage ? "h1" : "h2";
  const SubtitleTagName = title ? "div" : TagName;
  if (!title && !subtitle) return null;
  return (
    <div className={wrapperClassName}>
      {title && (
        <TagName
          className={ClassNames(
            moduleBaseStyles.Module__Title,
            `TextAlign--${textAlign.title}`,
            className,
            css({ color: scheme.main.title }),
          )}
        >
          {title}
        </TagName>
      )}
      {subtitle && (
        <SubtitleTagName
          className={ClassNames(
            moduleBaseStyles.Module__Subtitle,
            `TextAlign--${textAlign.subtitle}`,
            css({ color: scheme.main.text }),
          )}
        >
          <MultilineText text={subtitle} />
        </SubtitleTagName>
      )}
    </div>
  );
};

export default ModuleHeadings;
